import React, { createContext, useState } from "react";

export const ToasterContext = createContext(null);

function ToasterProvider({ children }) {
  const [toaster, setToaster] = useState({
    isOpen: false,
    message: "",
    severity: "success",
    autoClose: true,
  });

  return (
    <ToasterContext.Provider value={{ toaster, setToaster }}>
      {children}
    </ToasterContext.Provider>
  );
}

export { ToasterProvider };
